export const getAssetUrl = (path) => {
  if (!path) return '';
  let cleanPath = path;
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    if (path.includes('127.0.0.1') || path.includes('localhost') || path.includes(':8000')) {
      try {
        const parsed = new URL(path);
        cleanPath = parsed.pathname + parsed.search;
      } catch (e) {}
    } else {
      return path;
    }
  }
  
  if (cleanPath.startsWith('/')) {
    cleanPath = cleanPath.substring(1);
  }
  
  const pathname = window.location.pathname;
  const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

  if (isProduction) {
    if (pathname.startsWith('/react-app')) {
      return `/react-app/${cleanPath}`;
    }
    if (pathname.startsWith('/react/public')) {
      return `/react/public/${cleanPath}`;
    }
    if (pathname.startsWith('/react')) {
      return `/react/${cleanPath}`;
    }
  } else {
    if (pathname.startsWith('/react-app')) {
      return `/react-app/${cleanPath}`;
    }
  }
  
  return `/${cleanPath}`;
};
